<template>
    <!-- <div class="method-icon">
        <img v-if="currency === 'USD'" src="@/assets/img/wallets/method_icon/cashapp.png" />
        <img v-if="currency === 'TRY'" src="@/assets/img/wallets/method_icon/papara.png" />
        <img v-if="currency === 'BRL'" src="@/assets/img/wallets/method_icon/pix.png" />
        <img v-if="currency === 'NGN'" src="@/assets/img/wallets/method_icon/palmpay.png" />
        <img v-if="currency === 'INR'" src="@/assets/img/wallets/method_icon/imps.avif" />
        <div v-if="currency === 'BDT'">
            <img src="@/assets/img/wallets/method_icon/imps.avif" />
            <img src="@/assets/img/wallets/method_icon/gcash-1.png" />
        </div>
        <img v-else src="@/assets/img/wallets/method_icon/gcash-1.png" />
    </div> -->

    <div class="method-icons-container">
        <label v-for="(item, index) in IconsForCurrency" :key="index" class="method-icon" :class="{ selected: selectedMethod === index }">
            <input type="radio" :value="index" v-model="selectedMethod" :name="'method-' + currency" />
            <img :src="item.icon" class="icon" />
        </label>
    </div>
</template>
<script setup lang="ts">
const emits = defineEmits(['select_paytype'])
// const map = {
//     PHP: 'gcash',
//     USD: 'CashApp',
//     TRY: 'Papara',
//     BRL: 'Pix',
//     NGN: 'Palmpay',
//     INR: 'BANK',
// }
const Method_icons = {
    NGN: [{ icon: new URL('@/assets/img/wallets/method_icon/ngn_bank_icon.png', import.meta.url).href, paytype: 'antipay1' }],
    INR: [{ icon: new URL('@/assets/img/wallets/method_icon/imps.avif', import.meta.url).href, paytype: 'BANK' }],
    BDT: [
        { icon: new URL('@/assets/img/wallets/method_icon/EWALLET_NAGAD.png', import.meta.url).href, paytype: 'EWALLET_NAGAD' },
        { icon: new URL('@/assets/img/wallets/method_icon/EWALLET_BKASH.png', import.meta.url).href, paytype: 'EWALLET_BKASH' },
    ],
    PHP: [{ icon: new URL('@/assets/img/wallets/method_icon/gcash-1.png', import.meta.url).href, paytype: 'gcash' }],
    USDT: [{ icon: new URL('@/assets/img/wallets/method_icon/usdt.png', import.meta.url).href, paytype: 'usdt' }],
    KES: [{ icon: new URL('@/assets/img/wallets/method_icon/KES.png', import.meta.url).href, paytype: 'nairobi' }],
}
import { useBaseStore } from '@/stores'

const props = defineProps({
    paytype: {
        type: String,
        default: () => '',
    },
    selecttype: {
        type: String,
        default: () => '',
    },
})

const store = useBaseStore()

const currency = computed(() => store.wallet?.currency)
const selectedMethod = ref(0)

const IconsForCurrency = computed(() => {
    let icons = Method_icons[currency.value] || []

    if (props.paytype) {
        return icons.filter((item) => item.paytype === props.paytype)
    }
    return icons
})

watch(
    () => store.wallet?.currency,
    () => {
        selectedMethod.value = 0
    }
)

watch(
    () => selectedMethod.value,
    () => {
        emits('select_paytype', Method_icons[currency.value][selectedMethod.value].paytype)
    }
)

onMounted(() => {
    if (props.selecttype) {
        selectedMethod.value = IconsForCurrency.value.findIndex((item) => item.paytype === props.selecttype)
    }
    console.log('selecttype', props.selecttype, selectedMethod.value)
    if (!props.paytype) {
        emits('select_paytype', Method_icons[currency.value][selectedMethod.value].paytype)
    }
})
</script>
<style lang="scss" scoped>
// .method-icon {
//     position: relative;
//     margin: 0 auto;
//     width: 250px;
//     height: 88px;
//     border-radius: 10px;
//     overflow: hidden;
//     background-color: #202328;
//     border: 3px solid #00ff7f;

//     img {
//         max-width: inherit !important;
//         width: 80%;
//         height: auto;
//         position: absolute;
//         left: 50%;
//         top: 50%;
//         transform: translate(-50%, -50%);
//     }
// }
.container {
    width: 100%;
    max-width: 600px;
    background-color: #202328;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.method-icons-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}
.method-icon {
    width: 200px;
    height: 88px;
    border-radius: 8px;
    overflow: hidden;
    background-color: #202328;
    border: 2px solid #ddd;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.method-icon.selected {
    border-color: #00ff7f;
    box-shadow: 0 0 10px rgba(0, 255, 127, 0.5);
    background-color: rgba(24, 53, 41, 0.2);
}
.method-icon img {
    max-width: 80%;
    max-height: 80%;
    object-fit: contain;
}
.method-icon input[type='radio'] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}
</style>
